import { jsx } from "react/jsx-runtime";
import classnames from "../../utils/classnames.js";
import './FinanceProgram.css';/* empty css                    */
const FinanceProgramImage = ({
  alt,
  src,
  srcSet,
  sizes,
  className,
  wrapperClassName
}) => {
  if (!src && !srcSet) {
    return null;
  }
  return /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-finance-program-image-wrapper", wrapperClassName), children: /* @__PURE__ */ jsx(
    "img",
    {
      alt,
      src,
      srcSet,
      sizes,
      onError: ({ currentTarget }) => {
        currentTarget.onerror = null;
      },
      className: classnames("perxis-auto-finance-program-image", className)
    }
  ) });
};
export {
  FinanceProgramImage as default
};
//# sourceMappingURL=FinanceProgramImage.js.map
